import { Routes } from "@lifeat/shared/system/RouteConstants";
import { buildRoute } from "./RouteUtil";

export const redirectPersonalSpace = () => {
    window.open(buildRoute(Routes.App), "_self");
};

export const reloadPage = () => {
    window.location.reload();
};

export const clearCacheReloadPage = () => {
    localStorage.clear();
    sessionStorage.clear();
    reloadPage();
};

export const redirectTo = (redirectUrl: string, target = "_self") => {
    window.open(redirectUrl, target);
};

export const openLinkNewTab = (link: string): void => {
    if (link) {
        window.open(link, "rel=noopener");
    }
};

export const isLocalhost = (): boolean => {
    return window.location.origin.includes("localhost");
};

export const isExternalLink = (link: string): boolean => {
    const isAbsoluteLink = link.startsWith("//") || link.startsWith("http://") || link.startsWith("https://");
    if (!isAbsoluteLink) {
        // Relative links are not external
        return false;
    }
    const url = new URL(link);
    if (url.origin === window.location.origin) {
        // Same origin links are not external
        return false;
    }
    return true;
};

export const openPage = (openUrl: string, newTab: boolean) => {
    window.open(openUrl, newTab ? "rel=noopener" : "_self");
};

/**
 * Request permissions to access user's media devices.
 * @param options which device to access.
 * @returns True if the user allowed access. False otherwise.
 */
export const requestMediaPermissions = async (options: { audio: boolean; video: boolean }): Promise<boolean> =>
    navigator.mediaDevices
        .getUserMedia(options)
        .then(() => true)
        .catch(() => false);

/**
 * Create notification using default HTML5 notification standard.
 * https://developer.mozilla.org/en-US/docs/Web/API/Notification/Notification
 * Also is supported by ToDesktop for our desktop app: https://docs.todesktop.com/recipes/sending-notifications
 * @param title
 * @param options
 */
export const buildNotification = async (title: string, options?: NotificationOptions): Promise<Notification> => {
    if (!("Notification" in window)) {
        console.log("Desktop Notifications not supported in this browser.");
    } else {
        const existingPermission = Notification.permission;
        if (existingPermission === "granted") {
            return new Notification(title, options);
        } else {
            await Notification.requestPermission();
            const permissionAfterRequest = Notification.permission;
            if (permissionAfterRequest === "granted") {
                return new Notification(title, options);
            }
        }
    }
    throw new Error("Notification permission denied.");
};
